var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 9l8-8m0 8L1 1","stroke":"#1C1C1C","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }